import { useEffect } from 'react'
import { ContentStateInterface } from '../../../../../../@types/types'
import { useAppDispatch } from '../../../../../../app/hooks'
import { fetchRentIndexDebounced } from '../../../../../../redux/thunks/rentIndex/fetchRentIndexIfReady'

export function useLoadRentIndexData(insertionData: ContentStateInterface, enabled: boolean = true) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!enabled) {
      return
    }

    dispatch(fetchRentIndexDebounced())
  }, [
    enabled,
    insertionData.street,
    insertionData.city,
    insertionData.houseNumber,
    insertionData.postcode,
    insertionData.livingSpace,
    insertionData.constructionYear,
    insertionData.unknownConstructionYear,
    dispatch,
  ])
}
